import { observer } from "mobx-react"
import React, { useState, useCallback, useRef } from "react"
import "../../App.less"
import benifitsJson from "../../Configs/JSON/benifits.json"
import BenefitStore from "../../Configs/Store/benefit"
import AppStore from "../../Configs/Store/index"
import "../../styles/Benefits/Benefit.less"
import BenefitHeadText from "../Common/GenericComponenetHeader"
import Calculator from "../Calculator/Calculator"
import CalculatorStore from "../../Configs/Store/calculator"
import { DataLayerFn } from "../../Configs/API"
import { UserInput } from "../../Configs/API/calculation"
import CalculationAPI from "../../Configs/API/calculation"
import { amountValidation } from "../../Configs/Validator/FormValidations"
import { addCommas, removeCommas, num_to_words } from "../Common/CommonFunctions"

const regEx1 = /^0+/
const regEx2 = /^[0-9\b]+$/
const regEx3 = /^\d{1,10}$/
const AMOUNT_LIMITS = {
  minAmt: 1,
  maxAmt: 1000000000
}

const runCalculation = () => {
  CalculationAPI(
    CalculatorStore.ageValue,
    CalculatorStore.currentExpensesValue1 !== 0 && CalculatorStore.currentExpensesValue1 !== undefined ? CalculatorStore.currentExpensesValue1 : 0,
    CalculatorStore.currentExpensesValue2 !== 0 && CalculatorStore.currentExpensesValue2 !== undefined ? CalculatorStore.currentExpensesValue2 : 0,
    CalculatorStore.currentExpensesValue3 !== 0 && CalculatorStore.currentExpensesValue3 !== undefined ? CalculatorStore.currentExpensesValue3 : 0,
    CalculatorStore.retireAgeValue
  )
}

const handlecurrentExpenses = (e) => {
  let valsCurrent
  let evt
  if (CalculatorStore.showData === 1 && CalculatorStore.mainFlag === false) {
    evt = removeCommas(e)
  } else {
    evt = removeCommas(e.target.value)
    CalculatorStore.setAccurateResultValueHouse(0)
    CalculatorStore.setAccurateResultValueFood(0)
    CalculatorStore.setAccurateResultValueTransport(0)
    CalculatorStore.setAccurateResultValueEntertainment(0)
    CalculatorStore.setAccurateResultValueMiscellaneous(0)
  }

  let substr = evt.replace(CalculatorStore.currentChar, "")
  let compute = regEx3.test(evt) === true ? evt : substr
  let value = regEx2.test(compute) === true ? compute.toString().replace(regEx1, "") : substr

  valsCurrent = value === "" || isNaN(value) ? 0 : Number(value)
  CalculatorStore.setMultipleAmt(addCommas(valsCurrent))
  CalculatorStore.setValsNew(valsCurrent)
  CalculatorStore.setNumToWords(num_to_words(Math.round(valsCurrent)))

  if (CalculatorStore.screenNo === "Scr3") {
    CalculatorStore.setcurrentExpensesValue1(valsCurrent)
  } else if (CalculatorStore.screenNo === "Scr4") {
    CalculatorStore.setcurrentExpensesValue2(valsCurrent)
  } else if (CalculatorStore.screenNo === "Scr5") {
    CalculatorStore.setcurrentExpensesValue3(valsCurrent)
  }

  UserInput("screen", CalculatorStore.screenNo, "", "")
  let amountValidations = amountValidation(parseInt(valsCurrent), AMOUNT_LIMITS.minAmt, AMOUNT_LIMITS.maxAmt)
  CalculatorStore.setErrorAmount(amountValidations.valid)
  CalculatorStore.setErrorAmountMessage(amountValidations.errorMsg)
  amountValidations.valid === false ? CalculatorStore.setIsDisabled(true) : CalculatorStore.setIsDisabled(false)
  runCalculation()

  return valsCurrent
}

const handlecurrentExpenses_Accurate = (e) => {
  let valsAccurate
  let evt = removeCommas(e.target.value)
  let substr = evt.replace(CalculatorStore.currentChar, "")
  let compute = regEx3.test(evt) === true ? evt : substr
  let value = regEx2.test(compute) === true ? compute.toString().replace(regEx1, "") : substr

  valsAccurate = value === "" || isNaN(value) ? 0 : Number(value)
  CalculatorStore.setMainFlag(false)

  if (e.target.id === "accurateResult0") {
    CalculatorStore.setAccurateResultValueHouse(addCommas(valsAccurate))
  } else if (e.target.id === "accurateResult1") {
    CalculatorStore.setAccurateResultValueFood(addCommas(valsAccurate))
  } else if (e.target.id === "accurateResult2") {
    CalculatorStore.setAccurateResultValueTransport(addCommas(valsAccurate))
  } else if (e.target.id === "accurateResult3") {
    CalculatorStore.setAccurateResultValueEntertainment(addCommas(valsAccurate))
  } else if (e.target.id === "accurateResult4") {
    CalculatorStore.setAccurateResultValueMiscellaneous(addCommas(valsAccurate))
  }

  if (CalculatorStore.showData === 1) {
    let value = CalculatorStore.setMultipleAmt(
      addCommas(
        (
          parseInt(removeCommas(CalculatorStore.accurateResultValueHouse.toString())) +
          parseInt(removeCommas(CalculatorStore.accurateResultValueFood.toString())) +
          parseInt(removeCommas(CalculatorStore.accurateResultValueTransport.toString())) +
          parseInt(removeCommas(CalculatorStore.accurateResultValueEntertainment.toString())) +
          parseInt(removeCommas(CalculatorStore.accurateResultValueMiscellaneous.toString()))
        )
          .toString()
          .replace(regEx1, "")
      )
    )
    handlecurrentExpenses(value)
    CalculatorStore.setMainFlag(true)
  }

  return valsAccurate
}

const Benefits = observer((props) => {
  const device = AppStore.device
  let benifitContainer = null
  let [firstScreenFlag, setFirstScreenFlag] = useState(false)
  let [strokeDasharray, setStrokeDasharray] = useState("33, 100")
  let [stepNo, setStepNo] = useState("1/3")
  const typedAmountRef = useRef(false)

  if (device === 0) {
    benifitContainer = "benifitsMobileContainer benifits-container"
  } else {
    benifitContainer = "benifitsPCContainer benifits-container"
  }

  const commitAmount = useCallback((e) => {
    typedAmountRef.current = true
    return handlecurrentExpenses(e)
  }, [])

  const commitAccurate = useCallback((e) => {
    typedAmountRef.current = true
    return handlecurrentExpenses_Accurate(e)
  }, [])

  const handlenextbutton = useCallback((param_scrn) => {
    CalculatorStore.setIsDisabled(false)
    setFirstScreenFlag(true)
    CalculatorStore.setCalcPageScrn("first")
    var evntName = "Age"

    if (param_scrn === "Scr2") {
      if (UserInput.age < 18 || UserInput.age > 75) {
        CalculatorStore.setIsDisabled(true)
      }
    } else if (param_scrn === "Scr5") {
      CalculatorStore.setValsNew(0)
      CalculatorStore.setFifthScreenFlag(true)
      CalculatorStore.setShowData(0)
      CalculatorStore.setcurrentExpensesValue3(0)
      CalculatorStore.setMultipleAmt(0)
      CalculatorStore.setcurrentExpensesValue3(0)

      CalculatorStore.setAccurateResultValueHouse(0)
      CalculatorStore.setAccurateResultValueFood(0)
      CalculatorStore.setAccurateResultValueTransport(0)
      CalculatorStore.setAccurateResultValueEntertainment(0)
      CalculatorStore.setAccurateResultValueMiscellaneous(0)
      setStrokeDasharray("100, 100")
      setStepNo("3/3")
      if (CalculatorStore.screenNo === "Scr3") {
        evntName = "CurrentExpenses"
      } else if (CalculatorStore.screenNo === "Scr4") {
        evntName = "PostRetirementExpenses"
      }
    } else if (param_scrn === "Scr6") {
      evntName = "TotalSaving"
      CalculatorStore.setCalcPageScrn("last")
      CalculatorStore.setCustomRange1Text("Retirement Age")
      CalculatorStore.setminValue(40)
      CalculatorStore.setRangeInput(60)
      CalculatorStore.setbgSize(((60 - 40) / (CalculatorStore.maxValue - 40)) * 100)
    }

    try {
      DataLayerFn(`${evntName}_Selected`, CalculatorStore, "Next")
    } catch {}
    typedAmountRef.current === false && CalculatorStore.setMultipleAmt(0)
    typedAmountRef.current = false
    CalculatorStore.setscreenNo(param_scrn)
    UserInput("screen", CalculatorStore.screenNo, "", "")
    let amountValidations = amountValidation(parseInt(CalculatorStore.valsNew), AMOUNT_LIMITS.minAmt, AMOUNT_LIMITS.maxAmt)
    CalculatorStore.setErrorAmount(amountValidations.valid)
    CalculatorStore.setErrorAmountMessage(amountValidations.errorMsg)
    amountValidations.valid === false ? CalculatorStore.setIsDisabled(true) : CalculatorStore.setIsDisabled(false)

    runCalculation()
  }, [])

  const handlenextbuttonTab = useCallback((param) => {
    let temp_scr = param === "0" ? "Scr3" : "Scr4"
    let btn = ""
    let evntName = ""
    if (temp_scr === "Scr3") {
      CalculatorStore.setScr34ScreenFlag(0)
      btn = "Current Expenses"
      evntName = "CurrentExpenses"
    } else if (temp_scr === "Scr4") {
      CalculatorStore.setScr34ScreenFlag(1)
      btn = "Expected Post-Retirement Expenses"
      evntName = "PostRetirementExpenses"
    }

    CalculatorStore.setFifthScreenFlag(false)
    setStrokeDasharray("66, 100")
    setStepNo("2/3")
    CalculatorStore.setscreenNo(temp_scr)
    runCalculation()

    try {
      DataLayerFn(`${evntName}_Selected`, CalculatorStore, btn)
    } catch {}
  }, [])

  const handleBackButtonTab = useCallback((event) => {
    CalculatorStore.setShowData(0)
    CalculatorStore.setIsDisabled(false)
    setFirstScreenFlag(true)

    if (event.target.attributes[1].nodeValue === "Scr2") {
      CalculatorStore.setscreenNo("Scr1")
      setFirstScreenFlag(false)
    } else if (event.target.attributes[1].nodeValue === "Scr3") {
      CalculatorStore.setscreenNo("Scr2")
      setStrokeDasharray("33, 100")
      setStepNo("1/3")
    } else if (event.target.attributes[1].nodeValue === "Scr4") {
      CalculatorStore.setscreenNo("Scr2")
      setStrokeDasharray("33, 100")
      setStepNo("1/3")
    } else if (event.target.attributes[1].nodeValue === "Scr5") {
      CalculatorStore.setValsNew(0)
      CalculatorStore.setcurrentExpensesValue1(0)
      CalculatorStore.setcurrentExpensesValue2(0)
      CalculatorStore.setMultipleAmt(0)
      CalculatorStore.setcurrentExpensesValue1(0)
      CalculatorStore.setcurrentExpensesValue2(0)

      CalculatorStore.setAccurateResultValueHouse(0)
      CalculatorStore.setAccurateResultValueFood(0)
      CalculatorStore.setAccurateResultValueTransport(0)
      CalculatorStore.setAccurateResultValueEntertainment(0)
      CalculatorStore.setAccurateResultValueMiscellaneous(0)
      CalculatorStore.setFifthScreenFlag(false)
      setStrokeDasharray("66, 100")
      setStepNo("2/3")

      if (CalculatorStore.scr34ScreenFlag === 0) {
        CalculatorStore.setscreenNo("Scr3")
      } else {
        CalculatorStore.setscreenNo("Scr4")
      }
      UserInput("screen", CalculatorStore.screenNo, "", "")
    }

    if (event.target.attributes[1].nodeValue === "Scr3" || event.target.attributes[1].nodeValue === "Scr4" || event.target.attributes[1].nodeValue === "Scr5") {
      let amountValidations = amountValidation(parseInt(CalculatorStore.valsNew), AMOUNT_LIMITS.minAmt, AMOUNT_LIMITS.maxAmt)
      CalculatorStore.setErrorAmount(amountValidations.valid)
      CalculatorStore.setErrorAmountMessage(amountValidations.errorMsg)
      amountValidations.valid === false ? CalculatorStore.setIsDisabled(true) : CalculatorStore.setIsDisabled(false)
    }
    try {
      DataLayerFn("Back_Selected", CalculatorStore, "Back")
    } catch {}
  }, [])

  return (
    <div className={AppStore.device === 0 && "benifitandTitleContainerMob"}>
      {device === 0 && (
        <BenefitHeadText
          content={benifitsJson["BHTTitleText"]}
          icon={true}
          onClick={() => {
            BenefitStore.setAddBenefitModal(true)
          }}
        />
      )}
      <div className={AppStore.device === 1 ? `benifitContainerOnlyPC ${CalculatorStore.screenNo}` : null}>
        <div className={benifitContainer}>
          <div className="row">
            <div className={CalculatorStore.screenNo === "Scr1" ? "col-md-12 order-1 p-lg-0" : "col-md-6 order-1 p-lg-0"}>
              <div className="srcn-wrap" nextscrbutton={CalculatorStore.screenNo}>
                <div className={`benefitsHead ${CalculatorStore.screenNo}`}>
                  {firstScreenFlag && <div className="bttn-lnk BackBttn st" nextscrbutton={CalculatorStore.screenNo} onClick={handleBackButtonTab}></div>}
                  {firstScreenFlag && (
                    <div className="steps">
                      <svg viewBox="0 0 36 36" className="circular-steps">
                        <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                        <path className="circle" strokeDasharray={strokeDasharray} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                        <text x="18" y="23" className="step-no">
                          {stepNo}
                        </text>
                      </svg>
                    </div>
                  )}
                </div>
                <div className="retireContent">
                  <Calculator
                    onClickFunction={handlenextbuttonTab}
                    handlenextbutton={handlenextbutton}
                    handlecurrentExpenses={commitAmount}
                    handlecurrentExpenses_Accurate={commitAccurate}
                    handleAgeVal={props.handleAgeVal}
                  />
                </div>
                {CalculatorStore.fifthScreenFlag === true && (
                  <div className="footer">
                    <span className="footerText">Don’t include savings earmarked for other goals such as child education, marriage etc.</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})
export default Benefits
